import {
  setProductThumbEvents,
  setProductPageEvents,
  setPurchaseListEvents,
  setCheckoutEvents,
  setPurchaseEvent,
  setWishListEvent,
  setPromotionEvents,
  setTraficOriginEvents
} from './datalayer/mkx-events';
import { setUserData } from './datalayer/user-data.js';
import { DataLayerEvents } from './datalayer/data-layer-events.js';
import { DataLayerHandler } from './datalayer/data-layer-handler.js';

document.addEventListener('DOMContentLoaded', () => {
  try {
    DataLayerHandler.init();
    DataLayerEvents.init();
    setUserData();
    setPromotionEvents();
    setProductThumbEvents();
    setProductPageEvents();
    setWishListEvent();
    setPurchaseListEvents();
    setCheckoutEvents();
    setPurchaseEvent();
    setTraficOriginEvents();
  } catch (e) {
    console.error(e);
  }
});